import React from 'react';
import { Button } from '@blueprintjs/core';
import { Link } from 'react-router';
import { DropDownChonLoaiDonThu, DropDownTinhTrangGiaiQuyet, DropDownChonNguonDon, DropDownKetQuaGiaiQuyet } from 'components/tt-forms';
import { DatePicker, Input, InputTuKhoa } from 'components/tt-forms/common';
import { Checkbox } from '@blueprintjs/core';

let classNames = require('classnames');

class ListSearch extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tuKhoa: '',
      maDon: '',
      phanLoaiDon: '',
      isSaveTemp: false,
      nguonDon: '',
      tinhTrangGiaiQuyet: '',
      tiepNhanTuNgay: '',
      tiepNhanDenNgay: '',
      ketQuaGiaiQuyet: '',

      searching: this.props.disabled,
      spSearch: false,
      search: false,
      doSearch: false,
      searchLoading: false
    }
  }

  componentDidMount() {
    let data = localStorage.getItem(this.props.cookieName) ? JSON.parse(localStorage.getItem(this.props.cookieName)) : {};
    this.state.tuKhoa = data.hoTen || '';
    if (data.advanceSearch) {
      this.state.isSaveTemp = data.isSaveTemp;
      this.state.maDon = data.maDon || '';
      this.state.nguonDon = data.nguonDon || '';
      this.state.phanLoaiDon = data.phanLoaiDon || '';
      this.state.tinhTrangXuLy = data.trangThaiDonToanHT || '';
      this.state.ketQuaXuLy = data.ketQuaToanHT || '';
      this.state.startDate = data.tiepNhanTuNgay ? new Date(data.tiepNhanTuNgay) : '';
      this.state.endDate = data.tiepNhanDenNgay ? new Date(data.tiepNhanDenNgay) : '';
    }
  }

  handleSearch(e) {
    e.preventDefault();
    if (!this.props.advanceSearch) {
      this.setState({
        doSearch: true
      });
      this.props.handleSearch(this.state, e);
    } else {
      if(this.validateSubmitForm()) {
        this.setState({
          doSearch: true
        });
        this.props.handleSearch(this.state, e);
      }
    }
    return;
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    // if (!this.refs.containerFileDinhKem.validate()) {
    //   pass = false;
    // }
    return pass;
  }

  componentWillUnmount() {

  }

  cancel(e) {
    this.props.onCancel(e);
  }

  handleChange(name, e) {
    if (name === "isSaveTemp") {
      this.setState({isSaveTemp: !this.state.isSaveTemp});
    } else {
      this.setState({[name]: e.target.value});
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      searching: nextProps.disabled,
      doSearch: nextProps.search
    });
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  resetData() {
    this.setState({
      isSaveTemp: false,
      tuKhoa: '',
      maDon: '',
      phanLoaiDon: '',
      nguonDon: '',
      tinhTrangGiaiQuyet: '',

      tiepNhanTuNgay: '',
      tiepNhanDenNgay: '',

      ketQuaGiaiQuyet: '',

      searching: false,
      spSearch: false,
      search: false,
      doSearch: false,
      searchLoading: false
    })
  }

  render() {
    let classes = ['btn-green', 'tt-search'];

    if (this.state.searching) {
      classes.push('btn-disable');
    }
    if (this.state.doSearch) {
      classes.push('btn-loading');
    }

    let btnClasses = classNames(classes);

    return (
      <form className="search-form" onSubmit={ this.handleSearch.bind(this) }>
        <InputTuKhoa
        label="Từ khoá"
        className={this.state.spSearch ? 'col-40' : 'input-group-show'}
        value={this.state.tuKhoa}
        onChange={this.handleChange.bind(this, 'tuKhoa')}
        placeholder="Nhập tên người đứng đơn để tìm kiếm..." maxLength={255}/>
        <DatePicker className="input-20" label='Tiếp nhận từ ngày' bindValidator={this} channel="formTaoDon" endDate={ this.state.tiepNhanDenNgay } onChange={ this.handleChangeDate.bind(this, 'tiepNhanTuNgay')} value={this.state.tiepNhanTuNgay} />
        <DatePicker className="input-20" label='Đến ngày' bindValidator={this} channel="formTaoDon" startDate={ this.state.tiepNhanTuNgay } onChange={ this.handleChangeDate.bind(this, 'tiepNhanDenNgay')} value={this.state.tiepNhanDenNgay} />
        <Input label="Mã đơn" value={this.state.maDon}  className="input-20" onChange={this.handleChange.bind(this, 'maDon')} placeholder="Nhập mã đơn..."/>
        <div className="btn-wrap-20">
          <Button className={ btnClasses } text="Tìm kiếm" type="submit" disabled={ this.state.searching ? 'disabled' : '' } />
        </div>
        <DropDownChonNguonDon selectedValue={this.state.nguonDon} className="input-20 clear-left" onChange={this.handleChange.bind(this, 'nguonDon')}/>
        <DropDownChonLoaiDonThu selectedValue={this.state.phanLoaiDon} className="input-20" onChange={this.handleChange.bind(this, 'phanLoaiDon')}/>
        <DropDownTinhTrangGiaiQuyet selectedValue={this.state.tinhTrangGiaiQuyet} label="Tình trạng xử lý" className="input-20" onChange={this.handleChange.bind(this, 'tinhTrangGiaiQuyet')}/>
        <DropDownKetQuaGiaiQuyet selectedValue={this.state.ketQuaGiaiQuyet} className="input-20" onChange={this.handleChange.bind(this, 'ketQuaGiaiQuyet')}/>
        <div className="input-20">
          <Link
          className={ this.state.tableLoading ? "disable-super-search btn-disable-transparent" : "disable-super-search" }
          onClick={ this.cancel.bind(this) }>
            <i className="tt tt-delete"></i>Hủy tìm kiếm nâng cao
          </Link>
        </div>
        { this.props.onStatus === 'DANG_GIAI_QUYET' &&
          <div className="input-20 checkbox-luutam">
            <Checkbox className="pt-large" checked={this.state.isSaveTemp} onChange={this.handleChange.bind(this, 'isSaveTemp')} name="donLuuTam">
              <span>Đơn đã lưu tạm</span>
            </Checkbox>
          </div>
        }
      </form>
    );
  }
}

ListSearch.defaultProps = {
  validators: {},
  handleSearch: function() {
    console.log('Please assign handleSearch() method');
  },
  cookieName: 'gqdData',
  disabled: false,
  searching: false
}

export default ListSearch;



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/ListSearch.jsx